import { useQuery } from 'react-query';

import getDefaultCart from '@/common/api/carts/getDefaultCart';
import { ENDPOINT_DEFAULT_CART } from '@/common/constants';

const useDefaultCart = ({ isLoggedIn, source }) =>
  useQuery([ENDPOINT_DEFAULT_CART, source], getDefaultCart, {
    enabled: !!isLoggedIn, // Prevent fetching defaultCart in the user is not logged in
  });

export default useDefaultCart;
